module.exports = __webpack_public_path__ + "static/media/IMG_3376.e7716b77.png";